import { ChatSettingsAction } from './chat.actions';
import { ChannelSettingsChatTypes } from './chat.types';
import { ChatSettingsState } from './chat.state';

const chatSettingsReducer = (
    state: ChatSettingsState = {},
    action: ChatSettingsAction
) => {
    switch (action.type) {
        case ChannelSettingsChatTypes.GET_CHAT_CONFIG:
            return {
                ...state,
                [action.payload.brand]: {
                    isLoading: false,
                    chatConfig: action.payload.chatConfig,
                }
            };

        case ChannelSettingsChatTypes.GET_CHAT_CONFIG_LOADING:
            return {
                ...state,
                [action.payload.brand]: {
                    ...state[action.payload.brand],
                    isLoading: action.payload.isLoading,
                }
            };

        default:
            return state;
    }
};

export default chatSettingsReducer;
